import { lazy } from 'react';

import { withSuspenseFallback } from '../../../helpers/withSuspenseFallback';

const PizzasDashboard = lazy(() => import('../pages/dashboard/PizzasDashboard'));
const PizzaReports = lazy(() => import('../pages/reports/Reports'));
const Borders = lazy(() => import('../pages/borders/Borders'));
const Categories = lazy(() => import('../pages/categories/Categories'));
const Flavors = lazy(() => import('../pages/flavors/Flavors'));
const Ingredients = lazy(() => import('../pages/ingredients/Ingredients'));
const FlavorPrices = lazy(() => import('../pages/flavor-prices/FlavorPrices'));
const CategoriesPrices = lazy(() => import('../pages/categories-prices/CategoriesPrices'));
const IngredientsPrices = lazy(() => import('../pages/ingredient-prices/IngredientsPrices'));
const BordersPrices = lazy(() => import('../pages/border-prices/BordersPrices'));
const Totens = lazy(() => import('../pages/totens/Totens'));
const ConfigTotem = lazy(() => import('../pages/config-totem/ConfigTotem'));
const TotemImages = lazy(() => import('../pages/totem-images/TotemImages'));
const FlavorPricesDatePizza = lazy(() => import('../pages/flavor-prices/PricesDate'));
const CategoryPricesDatePizza = lazy(() => import('../pages/categories-prices/PricesDate'));
const IngredientPricesDatePizza = lazy(() => import('../pages/ingredient-prices/PricesDate'));
const BorderPricesDatePizza = lazy(() => import('../pages/border-prices/PricesDate'));

const baseRoute = '/pizzas';

const pizzasRoutes = [
  { path: `${baseRoute}/dashboard`, component: withSuspenseFallback(PizzasDashboard), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/reports`, component: withSuspenseFallback(PizzaReports), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/borders`, component: withSuspenseFallback(Borders), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/categories`, component: withSuspenseFallback(Categories), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/flavors`, component: withSuspenseFallback(Flavors), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/ingredients`, component: withSuspenseFallback(Ingredients), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/flavor-prices`, component: withSuspenseFallback(FlavorPrices), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/flavor-prices/prices-date`, component: withSuspenseFallback(FlavorPricesDatePizza), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/categories-prices`, component: withSuspenseFallback(CategoriesPrices), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/category-prices/prices-date`, component: withSuspenseFallback(CategoryPricesDatePizza), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/ingredients-prices`, component: withSuspenseFallback(IngredientsPrices), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/ingredient-prices/prices-date`, component: withSuspenseFallback(IngredientPricesDatePizza), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/borders-prices`, component: withSuspenseFallback(BordersPrices), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/border-prices/prices-date`, component: withSuspenseFallback(BorderPricesDatePizza), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/totens`, component: withSuspenseFallback(Totens), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/config-totem`, component: withSuspenseFallback(ConfigTotem), requiredRole: 'Pizza_System' },
  { path: `${baseRoute}/totem-images`, component: withSuspenseFallback(TotemImages), requiredRole: 'Pizza_System' },
];

export default pizzasRoutes;
